export default __webpack_public_path__ + "static/media/Flag_of_Argentina.f79ee67a.svg";